import * as $echarts from "echarts";
import { specialStyle } from "@/assets/utils/specialStyle";
import * as size from "../utils/chartSize";

const commonBarCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)

    // 绘制图表
    let option = {
        tooltip: {
            backgroundColor: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
            },

            formatter: `{b} <br/> 
                <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
                height:10px;background-color:#F7B500;'></span> {a0}: {c0} <br/>
                <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
                height:10px;background: linear-gradient(180deg, #42F3FF 0%, #2878FF 100%);'></span> {a1} : {c1}`,
        },
        grid: {
            left: chartSizeK,
            top: chartSizeJ,
            bottom: chartSizeI,
            right: chartSizeE,
        },
        legend: {
            data: [params.series[0].name, params.series[1].name],
            top: chartSizeM,
            right: chartSizeB,
            itemGap: chartSizeN,
            itemWidth: chartSizeF,
            itemHeight: chartSizeA,
            textStyle: {
                color: '#fff',
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
            },
            inactiveColor: '#ccc', // 图例关闭时的颜色
        },
        xAxis: [{
            data: params.xAxis,
            axisTick: { // 坐标轴刻度
                show: false,
            },
            // 刻度标签配置
            axisLabel: {
                color: "#FFF",
                rotate: 0,// 标签旋转
                margin: chartSizeN, // 标签与轴线间距
                fontFamily: 'Microsoft YaHei',
                fontSize: chartSizeA,
            },
            // 轴线配置
            axisLine: {
                show: true, // 显示坐标轴线
                lineStyle: { // 轴线样式
                    color: "rgba(255,255,255,0.6)",
                },
            },
        }],
        yAxis: [{
            splitLine: {
                lineStyle: {
                    color: "rgba(0, 145, 255, 0.3)",
                }
            },
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: "rgba(255, 255, 255, 0.6)"
                }
            },
            axisLabel: {
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
                color: "rgba(255, 255, 255, 0.65)"
            }
        }],
        series: [{
            name: params.series[0].name,
            data: params.series[0].data,
            type: 'line',
            smooth: true, // 线性
            symbolSize: chartSizeM,
            itemStyle: {
                color: "#F7B500"
            }
        }, {
            name: params.series[1].name,
            data: params.series[1].data,
            type: 'bar',
            barWidth: chartSizeN,
            itemStyle: {
                barBorderRadius: chartSizeM,
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: '#42F3FF' // 100% 处的颜色
                    }, {
                        offset: 1, color: '#2878FF' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
            },
        }, {
            type: 'pictorialBar',
            data: params.series[0].data,
            symbol: 'rect',
            itemStyle: {
                color: '#0f375f'
            },
            symbolRepeat: true,
            symbolSize: [chartSizeA, chartSizeL],
            symbolMargin: 1,
            z: -10,
        }]
    }
    params.chartId.setOption(option, true)
}

const pictorialCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)

    // 绘制图表
    let option = {
        tooltip: {
            backgroundColor: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
            },

            formatter: `{b} <br/> 
                <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
                height:10px;background-color:#42F3FF;'></span> {a0}: {c0}`,
            // 若每个图标颜色不一致 使用函数形式
            // formatter: function (params) {
            //     console.log(params);
            // },
        },
        grid: {
            left: chartSizeJ,
            top: chartSizeJ,
            bottom: chartSizeI,
            right: chartSizeE,
        },
        xAxis: {
            data: params.xAxis,
            axisLine: {
                show: false //隐藏X轴轴线
            },
            axisTick: {
                show: false //隐藏X轴轴线
            },
            axisLabel: {
                margin: chartSizeN,
                fontSize: chartSizeA,
                color: "#FFF",
                fontFamily: 'Microsoft YaHei',
            },
            axisLine: {
                show: true, // 显示坐标轴线
                lineStyle: { // 轴线样式
                    color: "rgba(255,255,255,0.6)",
                },
            },
        },
        yAxis: [{
            splitLine: {
                lineStyle: {
                    color: "rgba(0, 145, 255, 0.3)",
                }
            },
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: "rgba(255, 255, 255, 0.6)"
                }
            },
            axisLabel: {
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
                color: "rgba(255, 255, 255, 0.65)"
            }
        }],
        series: [{
            name: params.series.name,
            data: params.series.data,
            type: "bar",
            barWidth: chartSizeB,
            itemStyle: {
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: 'rgba(146, 225, 255, 1)' // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(0, 151, 251, 1)' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
            },
            z: 10,
            zlevel: 0
        },
        {
            // 分隔
            type: "pictorialBar",
            itemStyle: {
                color: "#0F375F"
            },
            symbolRepeat: "fixed",
            symbolMargin: 5,
            symbol: "rect",
            symbolClip: true,
            symbolSize: [chartSizeC, 2],
            symbolPosition: "start",
            data: [21, 43, 56, 32, 20],
            width: 2,
            z: 0,
            zlevel: 1
        },
        {
            name: "背影",
            type: "line",
            smooth: true, //平滑曲线显示
            showAllSymbol: false, //显示所有图形。
            symbolSize: 0,
            lineStyle: {
                width: 0
            },
            areaStyle: {
                color: "rgba(40, 122, 255, 0.3)"
            },
            data: [21, 43, 56, 32, 20],
            z: 5
        }
        ],
    }

    params.chartId.setOption(option, true)
}

export {
    commonBarCharts, pictorialCharts
}